import DPFeedbackIconTooltip, { FEEDBACK_TYPES } from "./DPFeedbackIconTooltip";

export { FEEDBACK_TYPES };
export default DPFeedbackIconTooltip;
